import { AdminInput, AdminToggle, AdminSelect, AdminSectionCard } from './AdminFormInput';
import ImagePicker from '@/components/ImagePicker';
import type { TemplateConfig } from '@/mocks/template-config';

interface FooterFormProps {
  config: TemplateConfig['footer'];
  onChange: (config: TemplateConfig['footer']) => void;
}

export default function FooterForm({ config, onChange }: FooterFormProps) {
  const update = <K extends keyof TemplateConfig['footer']>(key: K, value: TemplateConfig['footer'][K]) => {
    onChange({ ...config, [key]: value });
  };

  const updateQR = (updates: Partial<TemplateConfig['footer']['qrCode']>) => {
    update('qrCode', { ...config.qrCode, ...updates });
  };

  return (
    <div className="space-y-5">
      <AdminSectionCard title="Configuração do Rodapé" icon="ri-layout-bottom-line">
        <AdminSelect
          label="Modo do Rodapé"
          value={config.mode}
          onChange={(e) => update('mode', e.target.value as 'banner_full' | 'dynamic')}
          options={[
            { value: 'banner_full', label: 'Banner Completo' },
            { value: 'dynamic', label: 'Dinâmico' },
          ]}
        />
        <AdminToggle
          label="Mostrar Rodapé"
          checked={config.show}
          onChange={(v) => update('show', v)}
        />
        {config.mode === 'banner_full' && (
          <ImagePicker
            label="Imagem do Banner"
            value={config.bannerImage}
            onChange={(url) => update('bannerImage', url)}
            type="template"
            category="footer-banner"
          />
        )}
        <AdminSelect
          label="Overlay"
          value={config.overlay}
          onChange={(e) => update('overlay', e.target.value as 'dark' | 'light' | 'none')}
          options={[
            { value: 'dark', label: 'Escuro' },
            { value: 'light', label: 'Claro' },
            { value: 'none', label: 'Nenhum' },
          ]}
        />
      </AdminSectionCard>

      <AdminSectionCard title="QR Code" icon="ri-qr-code-line">
        <AdminToggle
          label="Mostrar QR Code"
          checked={config.qrCode.enabled}
          onChange={(v) => updateQR({ enabled: v })}
        />
        <AdminSelect
          label="Modo QR Code"
          value={config.qrCode.mode}
          onChange={(e) => updateQR({ mode: e.target.value as 'manual' | 'auto' })}
          options={[
            { value: 'manual', label: 'Manual (imagem)' },
            { value: 'auto', label: 'Automático (futuro)' },
          ]}
        />
        <ImagePicker
          label="URL da Imagem QR Code"
          value={config.qrCode.image}
          onChange={(url) => updateQR({ image: url })}
          type="template"
          category="qr-code"
        />
      </AdminSectionCard>

      <AdminSectionCard title="Visibilidade dos Campos" icon="ri-eye-line">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          <AdminToggle
            label="Telefone"
            checked={config.showPhones}
            onChange={(v) => update('showPhones', v)}
          />
          <AdminToggle
            label="WhatsApp"
            checked={config.showWhatsApp}
            onChange={(v) => update('showWhatsApp', v)}
          />
          <AdminToggle
            label="E-mail"
            checked={config.showEmail}
            onChange={(v) => update('showEmail', v)}
          />
          <AdminToggle
            label="Site"
            checked={config.showWebsite}
            onChange={(v) => update('showWebsite', v)}
          />
          <AdminToggle
            label="Cidade"
            checked={config.showCity}
            onChange={(v) => update('showCity', v)}
          />
          <AdminToggle
            label="CNPJ"
            checked={config.showCNPJ}
            onChange={(v) => update('showCNPJ', v)}
          />
          <AdminToggle
            label="Horário"
            checked={config.showHours}
            onChange={(v) => update('showHours', v)}
          />
          <AdminToggle
            label="Especialidades"
            checked={config.showSpecialties}
            onChange={(v) => update('showSpecialties', v)}
          />
        </div>
      </AdminSectionCard>
    </div>
  );
}